import { html, TemplateResult, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import encapsulatedStyles from './styles/outline-icon.base.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
/**
 * The element name, reused throughout the codebase
 * @type {string}
 */
const componentName = 'outline-icon';

/**
 * The Outline Core Icon component
 *
 * A reusable LitElement component for displaying icons.
 *
 * @element outline-icon
 * @extends LitElement
 */
@customElement(componentName)
export class OutlineIcon extends LitElement {
  /**
   * Adopted stylesheets for the component
   *
   * @type {AdoptedStyleSheets}
   */
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    encapsulatedCSS: encapsulatedStyles,
  });

  @property({ type: String })
  icon: string;

  @property({ type: String })
  color: string;

  @property({ type: String })
  size: string;

  @property({ type: String })
  padding: string;

  @property({ type: String, attribute: 'icon-classes' })
  iconClasses: string;

  @property({ type: Boolean })
  decorative = true;

  connectedCallback() {
    super.connectedCallback();
    this.updateVarsAndClasses();
  }

  updateVarsAndClasses() {
    if (this.size) {
      this.style.setProperty('--icon-size', `${this.size}`);
    }
    if (this.color) {
      this.style.setProperty('--icon-color', `${this.color}`);
    }
    if (this.padding) {
      this.style.setProperty('--icon-padding', `${this.padding}`);
    }
  }

  updated() {
    this.updateVarsAndClasses();
  }

  render(): TemplateResult {
    return html`
      <link
        rel="stylesheet"
        href="https://kit.fontawesome.com/e40642b092.css"
      />

      <div class="outline-icon">
        <i class="${this.iconClasses}" aria-hidden="${this.decorative ? true : false}"></i>
      </div>
    `;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineIcon;
  }
}
